import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/pt/personal-training.css";
import GlobalGymFilterAndHeading from "./GlobalGymFilterAndHeading";
// import TopTrainers from "./top-trainers/TopTrainers";
import AllPtMembers from "./all-pt-members/AllPtMembers";
import { selectAuth } from "../auth/auth.selector";
import TEPCommonCard from "./tepl-cards/common/TEPCommonCard";
import GTPTtrainers from "./pt-nonpt-trainers/GTPTtrainers";
import MealsStructure from "../diet/meal/MealsStructure";
import HelmetWrapper from "../../HelmetWrapper";
import TrainerDetailsAdmin from "./trainer-details/TrainerDetailsAdmin";
import PTTrainerPerformance from "./trainer-performance/PTTrainerPerformance";
import { isManagerRole as checkIsManagerRole } from "../common-data/Conversions";

const PersonalTraining = () => {
  const tableRef = useRef(null);
  const userInfo = useSelector(selectAuth);

  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const isAdmin = decryptedText?.account_type === "admin";
  // const isGym = decryptedText?.account_type === "gym";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isManagerRole = checkIsManagerRole(decryptedText);

  const [selectedGym, setSelectedGym] = useState("");
  const [startAndEndDate, setStartAndEndDate] = useState();
  const [selectedTrainer, setSelectedTrainer] = useState("");

  const selectedGymQueryParam = !isAdmin && !isManagerRole
    ? `&gym_id=${
        decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
      }`
    : (isAdmin || isManagerRole) && selectedGym?.value
    ? `&gym_id=${selectedGym.value}`
    : "";
  const selectedDatesQueryParam =
    startAndEndDate?.startDate && startAndEndDate?.endDate
      ? `&date_from=${startAndEndDate.startDate}&date_to=${startAndEndDate.endDate}`
      : startAndEndDate?.startDate
      ? `&date_from=${startAndEndDate.startDate}`
      : startAndEndDate?.endDate
      ? `&date_to=${startAndEndDate.endDate}`
      : "";
  const queryParametersForAll = `${selectedGymQueryParam}${selectedDatesQueryParam}`;

  let newQueryParametersForAll;
  if (selectedTrainer) {
    newQueryParametersForAll = `&trainer_id=${selectedTrainer}${queryParametersForAll}`;
  }

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Personal Training System">
      <Container fluid className="px-50px">
        <Row>
          <Col>
            <GlobalGymFilterAndHeading
              decryptedText={decryptedText}
              selectedGym={selectedGym}
              setSelectedGym={setSelectedGym}
              startAndEndDate={startAndEndDate}
              setStartAndEndDate={setStartAndEndDate}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <TEPCommonCard
              queryParametersForAll={queryParametersForAll}
              gymQP={selectedGymQueryParam}
              selectedGym={selectedGym}
              startAndEndDate={startAndEndDate}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <MealsStructure text={"Trainers PT Info"} />
          </Col>
        </Row>

        <Row>
          <Col>
            <GTPTtrainers queryParametersForAll={queryParametersForAll} />
          </Col>
        </Row>

        {!isTrainer ? (
          <Row>
            <Col>
              <PTTrainerPerformance
                userInfoData={decryptedText}
                prevSelGym={selectedGym}
                prevSelDate={startAndEndDate}
              />
            </Col>
          </Row>
        ) : null}
        {/* 
        <Row>
          <Col>
            <MealsStructure text={"Top PT Trainers"} />
          </Col>
        </Row>

        <br />

        <Row>
          <Col>
            <TopTrainers
              queryParametersForAll={queryParametersForAll}
              decryptedText={decryptedText}
              selectedTrainer={selectedTrainer}
              setSelectedTrainer={setSelectedTrainer}
              tableRef={tableRef}
            />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <AllPtMembers
              queryParametersForAll={
                newQueryParametersForAll
                  ? newQueryParametersForAll
                  : queryParametersForAll
              }
              tableRef={tableRef}
            />
          </Col>
        </Row>

        {isAdmin ? (
          <Row>
            <Col>
              <TrainerDetailsAdmin
                gymId={selectedGymQueryParam}
                selectedGym={selectedGym}
                queryParametersForAll={queryParametersForAll}
              />
            </Col>
          </Row>
        ) : null}
      </Container>
    </HelmetWrapper>
  );
};

export default PersonalTraining;
